var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogotssc2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 163 51",
    enableBackground: "new 0 0 163 51",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -0.1,
    y: 1.5,
    fill: "#1184A2",
    width: 32.2,
    height: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1184A2",
    d: "M-0.1,18.4v21.7c0,5.2,4.2,9.4,9.4,9.4h20.5V37.3H17.4c-2.2,0-3.9-1.8-3.9-3.9V18.4H-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1184A2",
    d: "M76.2,41.9c-2.7,8.3-10,7.8-10,7.8H38.8V37.6h21.3c0,0,2.5-2.6-1.4-7.8C54.8,24.6,43.2,17.2,39,11.9 c-4.2-5.3-2.1-10.4-2.1-10.4h17.3c0,0-0.1,1.9,0,2.3c0.1,1.9-0.3,5.2,8.5,11.8C66.9,18.8,80.4,28.6,76.2,41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1184A2",
    d: "M118.8,41.9c-2.7,8.3-10,7.8-10,7.8H81.4V37.6h21.3c0,0,2.5-2.6-1.4-7.8c-3.9-5.2-15.5-12.6-19.7-17.9 c-4.2-5.3-2.1-10.4-2.1-10.4h17.3c0,0-0.1,1.9,0,2.3c0.1,1.9-0.3,5.2,8.5,11.8C109.5,18.8,123,28.6,118.8,41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1184A2",
    d: "M163.1,0.5c0,0-26.6-4.5-36,10.4c-9.4,14.9-2.3,36.1,13.3,38.8c15.6,2.6,22.7,1.1,22.7,1.1V38.6 c0,0-11.7,3.5-21.1-3.7c-9.4-7.2-4.1-22.9,8.4-22.9c12.5,0,12.5,0,12.5,0L163.1,0.5z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotssc2);
export default __webpack_public_path__ + "static/media/logotssc2.628204bfa78d2e6b333c4274124cd982.svg";
export { ForwardRef as ReactComponent };